import React from "react";
import { Button, Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import "./ReportsEmpty.scss";
import emptyIllustration from "../../../../../common/assets/images/dashboard-list-empty.svg";

type EmptyType = "category" | "report";

type ReportEmptyProps = {
  type?: EmptyType;                  // defaults to "report"
  onAction?: () => void;             // optional callback
  title?: string;                    // optional custom title
  message?: string;                  // optional custom message
  buttonLabel?: string;              // optional custom button label
  showButton?: boolean;              // new prop to control button visibility
  disabled?: boolean;
  reportError?: any;
};

const ReportEmpty: React.FC<ReportEmptyProps> = ({
  type = "report",
  onAction,
  title,
  message,
  buttonLabel,
  showButton = true,
  disabled = false,
  reportError,
}) => {
  const isCategory = type === "category";

  const defaultMessage = isCategory
    ? showButton
      ? "You don’t have any Category created.\nPlease create a new category."
      : "You don’t have permission to create a category."
    : showButton
      ? "You don’t have any report created.\nPlease Add Report"
      : "You don’t have permission to create a report.";

  const defaultButtonLabel = isCategory ? "Create Category" : "Add Report";

  // If reportError exists → hide button
  const finalShowButton = showButton && !reportError;

  // Title & message priority: error → props → defaults
  const finalTitle = reportError ? undefined : title;

  const finalMessage = reportError
    ? reportError.message
    : message || defaultMessage;

  return (
    <section className="gdl-empty__container gdl-empty">
      <div className="gdl-empty__content">
        {finalTitle && <h3 className="gdl-empty__title">{finalTitle}</h3>}

        <p className="gdl-empty__text">
          {finalMessage.split("\n").map((line: string, idx: number) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>

        {finalShowButton && (
          <Button
            label={
              <span className="btn-with-icon">
                {buttonLabel || defaultButtonLabel}
                <Iconography icon="plus" size={IconographySizes.Small} />
              </span>
            }
            variant="secondary"
            color="primary"
            title={buttonLabel || defaultButtonLabel}
            disabled={disabled}
            onClick={() => {
              if (!disabled) onAction?.();
            }}
          />
        )}
      </div>

      <div className="gdl-empty__art" aria-hidden="true">
        <img src={emptyIllustration} alt="" />
      </div>
    </section>
  );
};


export default ReportEmpty;
